/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hour_Equal_Ocelot_BubbleInputs */

const fr_hour_equal_ocelot_bubble = /** @type {(inputs: Hour_Equal_Ocelot_BubbleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

/**

* @param {Hour_Equal_Ocelot_BubbleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const hour_equal_ocelot_bubble = /** @type {((inputs?: Hour_Equal_Ocelot_BubbleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hour_Equal_Ocelot_BubbleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_hour_equal_ocelot_bubble(inputs)
});